import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderService } from 'onego-header';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { TenantService } from '../services';
import { AppStateService } from '../services/state';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
    private readonly headerService = inject(HeaderService);
    private readonly tenantService = inject(TenantService);
    private readonly appState = inject(AppStateService);
    private readonly router = inject(Router);

    public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(req).pipe(
            catchError((e) => {
                const errorResponse = e as HttpErrorResponse;
                if (errorResponse.status === 401) {
                    this.appState.returnUrl.value = this.router.url;

                    this.headerService.logout();
                    this.tenantService.selectTenant(null, null);
                    this.router.navigate(['/']);
                }
                return throwError(e);
            })
        );
    }
}
